import { memo } from 'react';
import { type NodeProps } from 'reactflow';
import { DatabaseBackup } from 'lucide-react';
import { BaseNodeUI } from './BaseNodeUI';

const RelaySinkNode = ({ data, selected }: NodeProps) => (
    <BaseNodeUI
        title={data.label || 'Relay Sink'}
        icon={DatabaseBackup}
        colorClass=""
        bgClass="bg-gradient-to-br from-emerald-500 to-emerald-700"
        selected={selected}
        executionStatus={data?.executionStatus}
        isRunning={data?.executionStatus === 'Running'}
        isSource={false}
        isTarget={true}
    />
);

export default memo(RelaySinkNode);
